/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	COOKIE_DIALOG_ACCEPT,
	GA4_EVENT_COOKIE_DIALOG_ACCEPT,
	PAGE_DATA_LAYER,
} from '@/data/constants/gtm';
import { getGTMCookieDialogAcceptEventData } from '@/data/events/data/gtm/CookieDialogAccept';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMCookieDialogAcceptPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (
	data: Awaited<ReturnType<typeof getGTMCookieDialogAcceptEventData>>
) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: GA4_EVENT_COOKIE_DIALOG_ACCEPT,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const measure_UA = async (
	data: Awaited<ReturnType<typeof getGTMCookieDialogAcceptEventData>>
) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: COOKIE_DIALOG_ACCEPT,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const sendGTMCookieDialogAcceptEvent = async (payload: GTMCookieDialogAcceptPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = await getGTMCookieDialogAcceptEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(
					undefined,
					'CookieDialogAccept: sendGTMCookieDialogAcceptEvent: measure_UA: error: %o',
					error
				);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(
					undefined,
					'CookieDialogAccept: sendGTMCookieDialogAcceptEvent: measure_GA4: error: %o',
					error
				);
			}
		}
	}
};
